import React, { createContext, useContext, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

const ShareWithContext = createContext();

export const useShareWith = () => useContext(ShareWithContext);

const ShareWithProvider = ({ children }) => {
  const [recipient, setRecipient] = useState(null);
  const { data } = useSelector(s => s.caseDetail);
  const submitted = !data.isDraft;

  const updateRecipient = newRecipient => {
    setRecipient(newRecipient);
  };

  return (
    <ShareWithContext.Provider
      value={{ recipient, updateRecipient, submitted, isIntel: data.isIntel }}
    >
      {children}
    </ShareWithContext.Provider>
  );
};

ShareWithProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default ShareWithProvider;
